// src/models/pedidos/Pedido.js
import OrigemPedidoEnum from "./OrigemPedidoEnum";
import { enderecoPessoaParaCampos } from '../../utils/enderecoUtils';
import { parseNumeric } from '../../utils/numberUtils';
export class Pedido {
    static validarEnderecoEntrega(dados = {}, usarTaxaEntregaBairro = false) {
        const campos = enderecoPessoaParaCampos(dados);
        const erros = {};
        if (!campos.logradouro) erros.logradouro = 'Rua é obrigatória para entrega';
        if (!campos.numero) erros.numero = 'Número é obrigatório para entrega';
        if (!campos.bairro) erros.bairro = 'Bairro é obrigatório para entrega';
        if (usarTaxaEntregaBairro && !Number(dados.taxaEntregaBairroId)) {
            erros.taxaEntregaBairroId = 'Bairro é obrigatório para entrega';
        }
        return erros;
    }

    static prepararEnderecoEntrega(dados, iniciais, usarTaxaEntregaBairro, taxasEntregaBairro = []) {
        const taxaEntregaBairroId = usarTaxaEntregaBairro ? Number(dados.taxaEntregaBairroId) || null : null;
        const bairroAlterado = usarTaxaEntregaBairro
            && taxaEntregaBairroId !== (Number(iniciais.taxaEntregaBairroId) || null);
        const taxaBairro = taxasEntregaBairro.find((taxa) => Number(taxa.id) === taxaEntregaBairroId);
        return {
            ...enderecoPessoaParaCampos(dados),
            taxaEntregaBairroId,
            taxaEntrega: parseNumeric(bairroAlterado ? taxaBairro?.valor : iniciais.taxaEntrega),
        };
    }

    constructor(
        id = 0,
        statusPedido = null,
        clienteAppId = null,
        origemPedido = OrigemPedidoEnum.PDV,
        nomeCliente = null,
        enderecoCliente = null,
        formaPagId = null,
        tipoEntregaId = null,
        comandaId=null,
        dataHoraPedido = null,
        dataHoraPrevisao = null,
        horaPrevisao = null,
        dataHoraEntrega = null,
        observacao = null,       
        valorItens = 0,
        taxaEntrega = 0,
        valorAcrescimo = null,
        valorDesconto = null,
        valorTotal = 0,
        pedidoItens = [], 
        avulso = false,
        dataHoraAgendada = null,
        horaAgendada = null,
        pixPago = false,
        taxaEntregaBairroId = null,
        localizacao = null
    ) {
        this.id = id;                            // int
        this.statusPedido = statusPedido;      // StatusPedido? (nullable)
        this.clienteAppId = clienteAppId;        // int? (nullable)
        this.origemPedido = origemPedido;        // OrigemPedidoEnum? (nullable)
        this.nomeCliente = nomeCliente;          // string? (nullable)
        this.enderecoCliente = enderecoCliente;  // string? (nullable)
        this.formaPagId = formaPagId;            // int? (nullable)
        this.tipoEntregaId = tipoEntregaId;      // int? (nullable)
        this.comandaId = comandaId;
        this.dataHoraPedido = dataHoraPedido;    // DateTime? (nullable)
        this.dataHoraPrevisao = dataHoraPrevisao;// DateTime? (nullable)
        this.horaPrevisao = horaPrevisao;        // string? (nullable)
        this.dataHoraEntrega = dataHoraEntrega;  // DateTime? (nullable)   
        this.observacao = observacao;            // string? (nullable)
        this.valorItens = valorItens;            // decimal
        this.taxaEntrega = taxaEntrega;          // decimal
        this.valorAcrescimo = valorAcrescimo;    // decimal
        this.valorDesconto = valorDesconto;      // decimal
        this.valorTotal = valorTotal;            // decimal
        this.pedidoItens = pedidoItens;          // List<PedidoItem>? (nullable)
        this.avulso = avulso;                    // boolean
        this.dataHoraAgendada = dataHoraAgendada;// DateTime? (nullable)
        this.horaAgendada = horaAgendada;        // string? (nullable)
        this.pixPago = pixPago;                  // boolean
        this.taxaEntregaBairroId = taxaEntregaBairroId;
        this.localizacao = localizacao;          // string? (nullable) - link do Google Maps informado pelo cliente no App
    }

    // Indica se o cliente informou a localização (link do Google Maps) no App de Delivery
    static possuiLocalizacao(pedido) {
        return typeof pedido?.localizacao === 'string' && pedido.localizacao.trim() !== '';
    }

    // Extrai latitude e longitude do link de localização (ex.: ...maps/search/?api=1&query=-15.66,-56.09)
    static obterCoordenadasLocalizacao(localizacao) {
        const texto = decodeURIComponent((localizacao ?? '').toString());
        const encontrado = texto.match(/(-?\d{1,2}(?:\.\d+)?)\s*,\s*(-?\d{1,3}(?:\.\d+)?)/);
        if (!encontrado) return null;

        const latitude = Number(encontrado[1]);
        const longitude = Number(encontrado[2]);
        if (Math.abs(latitude) > 90 || Math.abs(longitude) > 180) return null;

        return { latitude, longitude };
    }

    // URL do mapa incorporado (iframe) a partir do link de localização
    static montarUrlMapaLocalizacao(localizacao) {
        const coordenadas = Pedido.obterCoordenadasLocalizacao(localizacao);
        if (!coordenadas) return null;

        return `https://maps.google.com/maps?q=${coordenadas.latitude},${coordenadas.longitude}&z=17&hl=pt-BR&output=embed`;
    }
}
